import {
	PermissionType,
	ShareBaseDocument,
	WopiDiscoveryInfo
} from 'phoenix/domain';
import { IUriPathService } from 'phoenix/services';
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';

export class OfficeOnlineService {
	public static $inject = [
		'$http',
		'pxUriPathService',
		'sbAclDatastore',
	];

	constructor(
		private $http:ng.IHttpService,
		private pxUriPathService:IUriPathService,
		private sbAclDatastore:AclDatastore,
	) {
	}

	public discover(document:ShareBaseDocument) {
		if (!this.sbAclDatastore.hasPermission(document, PermissionType.MODIFY)) {
			throw new Error('You must have edit rights to the document to edit in Office Online.');
		}

		let fileId = document.Embedded.LatestFile.FileId;
		let fileExtension = `.${document.DocumentName.split('.').pop()}`;

		return this.$http
			.get<WopiDiscoveryInfo>(this.pxUriPathService.resolvePath(`/wopi/discovery/${fileId}{?fileExtension}`, { fileExtension }))
			.then(res => res.data);
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/services/officeOnlineService.ts